import { connect } from 'react-redux';
import MessageComponent from './../../components/Message';
import { removeMessage } from './../../actions/messages';

export const mapStateToProps = ({ message: { type, message, messageId } }) => ({
  type,
  message,
  messageId,
});

const MessageContainer = connect(mapStateToProps, { removeMessageById: removeMessage })(MessageComponent);

export default MessageContainer;



// WEBPACK FOOTER //
// ./src/app/containers/Message/index.js